import React from "react";
import styles from "../../../pages/styles";
import { logowithclouds, teacherskyler, teacherevan, teacheraustin, teachertyler } from "../../../assets/images";
import { Circle } from "lucide-react";

const Instructors = () => {
  const instructors = [
    {
      name: "Skyler Cameron",
      image: teacherskyler,
      role: "Full Stack Development Expert",
      points: [
        "Full Stack Developer 10+ Years",
        "Multiple Programming Certifications",
        "Published Game Developer",
        "Senior Development Roles"
      ]
    },
    {
      name: "Evan Stern",
      image: teacherevan,
      role: "Senior Game Developer",
      points: [
        "12+ Years Industry Experience",
        "Senior Development Roles",
        "Disney Marvel Projects",
        "Warner Bros Game Developer"
      ]
    },
    {
      name: "Jacob Bloch",
      image: logowithclouds,
      role: "Game Development Expert",
      points: [
        "2D Game Development Specialist",
        "Longtime Game Dev Instructor",
        "Multiple Published Games",
        "Certified Teaching Experience",
        "Minecraft Modding"
      ]
    },
    {
      name: "Austin Weeks",
      image: teacheraustin,
      role: "Unity & AI Specialist",
      points: [
        "Unity and AI Engineer",
        "Certified Website Developer",
        "'Seas of Rebellion' Creator",
        "Game Design Instructor"
      ]
    },
    {
      name: "Tyler Burgents",
      image: teachertyler,
      role: "Game Development Expert",
      points: [
        "Bachelors in Game Design",
        "Construct 3 Expert",
        "Digital Design Expert",
        "Unity Expert"
      ]
    }
  ];

  return (
    <div className="bg-whiteprimary py-8 md:py-10 px-4 md:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-6 md:mb-8">
          <h2 className={`${styles.biggerheadingdark} mb-3 md:mb-4`}>Meet Your Tech Mentors</h2>
          <p className={`${styles.paragraph}`}>
            Industry professionals turned passionate educators
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {instructors.map((instructor, index) => {
            const isJacob = instructor.name === "Jacob Bloch";
            
            return (
              <div 
                key={index}
                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all border-2 border-gray-200 hover:border-orangeprimary flex flex-col"
              >
                <div className="flex justify-center mb-5">
                  <div className={`${isJacob ? 'w-28 h-28 md:w-32 md:h-32' : 'w-24 h-24 md:w-28 md:h-28'} rounded-full border-3 border-orangeprimary shadow-md overflow-hidden bg-darkprimary flex items-center justify-center`}>
                    <img 
                      src={instructor.image} 
                      alt={instructor.name}
                      className={`w-full h-full ${isJacob ? 'object-contain p-2' : 'object-cover'}`}
                    />
                  </div>
                </div>

                <div className="text-center mb-5">
                  <h3 className={`${styles.headingdark} text-lg md:text-xl font-bold mb-1`}>{instructor.name}</h3>
                  <p className={`${styles.paragraph} text-sm text-gray-600`}>{instructor.role}</p>
                </div>

                <ul className="space-y-2.5 flex-1">
                  {instructor.points.map((point, i) => {
                    return (
                      <li 
                        key={i}
                        className="flex items-center gap-2.5"
                      >
                        <Circle className="w-2.5 h-2.5 text-darkprimary flex-shrink-0 fill-darkprimary" />
                        <span className={`${styles.paragraph} text-sm text-gray-700`}>{point}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Instructors;